var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:['error-modal', { 'is-static': this.isStatic }]},[_c('i',{staticClass:"material-icons text-error"},[_vm._v("warning")]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.errorMessage)}})])}
var staticRenderFns = []

export { render, staticRenderFns }